// Avancement d'une étape en cours (step_progress, contrat v1.8, MCP-13) mis en forme pour le
// panneau de raisonnement : « étape 3/12 · Mois 3 sur 12 » à l'écran, « étape 3 sur 12, Mois 3 sur
// 12 » pour les lecteurs d'écran (aria-valuetext de la barre), largeur de la barre en pour cent.
// n appels terminés sur N connus : N peut grandir (liste paginée : « Page 1 sur 1 », puis sur 7),
// la barre recule alors. Le libellé est celui du MCP : « Mois 3 sur 12 » compte des appels
// terminés, ce n'est pas le 3e mois du calendrier.

const nombre = (v) => new Intl.NumberFormat('fr-FR').format(v);

/** {texte, valeurTexte, pourcentage} ; null sans progression lisible. */
export function formatStepProgress(progress) {
  if (!progress || typeof progress !== 'object') return null;
  const { n, N } = progress;
  if (!Number.isInteger(n) || !Number.isInteger(N) || n < 0 || N < 1) return null;
  const etape = typeof progress.etape === 'string' ? progress.etape.trim() : '';
  const court = `étape ${nombre(n)}/${nombre(N)}`;
  const long = `étape ${nombre(n)} sur ${nombre(N)}`;
  return {
    texte: etape ? `${court} · ${etape}` : court,
    valeurTexte: etape ? `${long}, ${etape}` : long,
    pourcentage: Math.min(100, Math.max(0, Math.round((n / N) * 100))),
  };
}
